import Vue from 'vue'

Vue.filter('displayState', function(publishedAt) {
  const isPublished = moment().isSameOrAfter(publishedAt)
  const status = isPublished ? 'published-entry' : 'draft-entry'
  return `<i class="fa fa-circle photonTreeIcon ${status}"></i>`
})
